import { ShieldAlert } from "lucide-react";
import { cn } from "@/lib/utils";

const toneClasses = {
  "lower-concern": "border-emerald-200 bg-emerald-50 text-emerald-800",
  "moderate-caution": "border-amber-200 bg-amber-50 text-amber-800",
  "elevated-concern": "border-orange-200 bg-orange-50 text-orange-800",
  "severe-advisory": "border-rose-200 bg-rose-50 text-rose-800",
};

export const CountrySafetySignal = ({
  safetyProfile,
  variant = "inline",
  showContext = false,
  dataTestIdPrefix = "country-safety-signal",
}) => {
  if (!safetyProfile?.advisory_label || !safetyProfile?.signal_label) {
    return null;
  }

  const toneClassName = toneClasses[safetyProfile.tone] || toneClasses["moderate-caution"];

  if (variant === "callout") {
    return (
      <div
        className={cn("rounded-[1.25rem] border px-4 py-3", toneClassName)}
        data-testid={`${dataTestIdPrefix}-callout`}
      >
        <div className="flex items-start gap-3">
          <ShieldAlert className="mt-0.5 h-4.5 w-4.5 flex-shrink-0" />
          <div className="space-y-1">
            <p className="text-sm font-medium" data-testid={`${dataTestIdPrefix}-label`}>
              {safetyProfile.advisory_label} · {safetyProfile.signal_label}
            </p>
            {showContext && safetyProfile.context_note ? (
              <p className="text-sm leading-7" data-testid={`${dataTestIdPrefix}-context`}>
                {safetyProfile.context_note}
              </p>
            ) : null}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="mt-2 space-y-1" data-testid={`${dataTestIdPrefix}-inline`}>
      <p className="text-xs text-stone-500" data-testid={`${dataTestIdPrefix}-label`}>
        {safetyProfile.advisory_label} · {safetyProfile.signal_label}
      </p>
      {showContext && safetyProfile.context_note ? (
        <p className="text-xs leading-6 text-stone-500" data-testid={`${dataTestIdPrefix}-context`}>
          {safetyProfile.context_note}
        </p>
      ) : null}
    </div>
  );
};